import { RouterProvider } from '@tunasong/ui-lib'
import React from 'react'
import router from './router.js'

export interface AppProps {}

export const App: React.FC<AppProps> = () => <RouterProvider router={router} />

export default App
